var _rect, _rect2, _rect3, _path, _rect4, _ellipse, _path2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateDeliveredOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5181,
    y: 59.7676,
    width: 24.1448,
    height: 1.99978,
    rx: 0.999891,
    fill: "url(#paint0_linear_667_11757)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.96,
    y: 56.001,
    width: 13.1167,
    height: 1.99978,
    rx: 0.999891,
    fill: "url(#paint1_linear_667_11757)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3086,
    y: 50.9844,
    width: 7.875,
    height: 1.99978,
    rx: 0.999891,
    fill: "url(#paint2_linear_667_11757)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6215 44.8223C35.3381 45.5813 30.9527 57.5947 31.442 64.8054H66.7181C67.5837 58.0164 63.7352 46.024 49.6215 44.8223Z",
    fill: "url(#paint3_linear_667_11757)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2461,
    y: 63.4277,
    width: 39.6072,
    height: 3.79312,
    rx: 1.89656,
    fill: "url(#paint4_linear_667_11757)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8528,
    cy: 44.824,
    rx: 2.55837,
    ry: 2.04368,
    fill: "#DDDEDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2142 28.6228C45.2552 26.9936 45.8987 24.9838 46.0308 22.6609C46.0308 16.6452 41.1541 11.7686 35.1384 11.7686C29.1228 11.7686 24.2461 16.6452 24.2461 22.6609C24.588 25.4051 25.3724 27.6028 26.5427 29.2737L34.6375 42.3072C35.0364 42.9495 35.9764 42.9338 36.3536 42.2785L44.2142 28.6228Z",
    fill: "url(#paint5_linear_667_11757)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1386,
    cy: 22.3051,
    r: 4.51411,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_11757",
    x1: 19.1928,
    y1: 61.7674,
    x2: 42.6627,
    y2: 61.7674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADEAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_11757",
    x1: 12.3265,
    y1: 58.0008,
    x2: 25.0766,
    y2: 58.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADEAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_667_11757",
    x1: 20.5287,
    y1: 52.9842,
    x2: 28.1836,
    y2: 52.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADEAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_667_11757",
    x1: 49.182,
    y1: 44.8223,
    x2: 49.182,
    y2: 62.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_667_11757",
    x1: 49.0497,
    y1: 63.4277,
    x2: 49.0497,
    y2: 67.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_667_11757",
    x1: 35.1384,
    y1: 11.7686,
    x2: 35.1384,
    y2: 42.7796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEFD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateDeliveredOn);
export default __webpack_public_path__ + "static/media/state_delivered_on.7466973b9c8e1ba7e53cd019ef543866.svg";
export { ForwardRef as ReactComponent };